// extracted by mini-css-extract-plugin
export var carouselWrapper = "hero-carousel-module--carouselWrapper--vWyRW";
export var carouselImage = "hero-carousel-module--carouselImage--GGGYi";